import { PageHero } from "@/components/PageHero";
import { usePageMeta } from "@/hooks/usePageMeta";

function DraftBanner() {
  return (
    <div className="rounded-lg border border-gold/40 bg-gold/10 px-5 py-4 text-sm text-navy">
      <strong>Draft for owner review.</strong> This is placeholder language provided for review before
      launch. It is not legal advice. Please have it reviewed and finalized before publishing.
    </div>
  );
}

export default function Privacy() {
  usePageMeta("Privacy Policy", "Privacy Policy for Lord Almighty (draft for review).");
  return (
    <div>
      <PageHero eyebrow="Legal" title="Privacy Policy" />
      <section className="mx-auto max-w-3xl px-5 lg:px-8 py-16 space-y-6 text-muted-foreground leading-relaxed">
        <DraftBanner />
        <p>Lord Almighty ("we," "us") respects your privacy. This policy explains what information we
          collect through this website and how we use it.</p>
        <h2 className="font-display text-2xl text-navy pt-2">Information we collect</h2>
        <p>We collect only the information you choose to provide through our forms — such as your name,
          email, phone number, organization, and the details of your inquiry or business submission.
          We do not knowingly collect personal information from children.</p>
        <h2 className="font-display text-2xl text-navy pt-2">How we use information</h2>
        <p>We use your information to respond to inquiries, review business directory submissions, and
          communicate with you about this work. We do not sell your personal information.</p>
        <h2 className="font-display text-2xl text-navy pt-2">Data storage & security</h2>
        <p>Submissions are stored in our database and are accessible only to authorized administrators.
          Email notifications are sent through an owner-approved email provider.</p>
        <h2 className="font-display text-2xl text-navy pt-2">Your choices</h2>
        <p>You may request access to, correction of, or deletion of the information you have submitted
          by contacting us through the Connect & Partner page.</p>
        <h2 className="font-display text-2xl text-navy pt-2">Contact</h2>
        <p>Questions about this policy can be sent through our contact form. A dedicated contact address
          will be published once available.</p>
      </section>
    </div>
  );
}
